import {
  Box,
  constants,
  PageSection,
  Stack,
  Text,
} from '@redbubble/design-system';
import { ErrorBoundary } from '@redbubble/next/error-boundary';
import { FormattedMessage } from '@redbubble/next/intl';
import { NextPage } from 'next/types';
import { TrustSignalsGroup } from '../../../i/components/TrustSignalsGroup';
import type { CategorySearchResultsPageProps } from '../../types';

export const CategoryPage: NextPage<CategorySearchResultsPageProps> = ({
  config,
}) => (
  <Box element="main">
    <PageSection size={constants.MEDIUM}>
      <Stack spacing="l">
        <Text element="h1" type="display1">
          <FormattedMessage {...config.title} />
        </Text>
        {/*
         * Placeholders for the L2 pills and carousels
         * https://articore.atlassian.net/browse/DEAP-4402
         * https://articore.atlassian.net/browse/DEAP-4186
         */}
        <Text
          element="p"
          type="body"
          display="block"
          muted
          data-testid="category-pills-placeholder"
        >
          L2 pills coming soon
        </Text>
        <Text
          element="p"
          type="body"
          display="block"
          muted
          data-testid="category-carousels-placeholder"
        >
          L2 carousels coming soon
        </Text>
        {/*
         * TODO(DEAP): Confirm whether SPC / related-topics content. Placeholder only for now
         * remove if product decides it's out of scope.
         */}
        <Text
          element="p"
          type="body"
          display="block"
          muted
          data-testid="category-related-content-placeholder"
        >
          SPC / related topics content coming soon (confirm scope)
        </Text>
        <ErrorBoundary>
          <TrustSignalsGroup />
        </ErrorBoundary>
      </Stack>
    </PageSection>
  </Box>
);
